// Post-clone provisioning API (server: cloudforge, prd-north-commerce-provisioning).
// Real stages come from the server's pending_provisions row:
//   pending -> configuring -> creating_admin -> ready | failed

import axiosInstance from './axiosConfig';
import { authHeaders } from './billingApi';

// GET the real provisioning stage: { stage, failed_reason?, updated_at }.
export const getProvisioningStatus = async (siteId) => {
  const response = await axiosInstance.get(
    `sites/${siteId}/provisioning-status`,
    authHeaders(),
  );
  return response.data;
};

// Mint a one-time magic-login URL: { url, expires }. 409 until the site is ready.
export const getWpLoginLink = async (siteId) => {
  const response = await axiosInstance.get(`sites/${siteId}/wp-login`, authHeaders());
  return response.data;
};

// Re-run provisioning for a failed site (409 unless failed).
export const retryProvisioning = async (siteId) => {
  const response = await axiosInstance.post(
    `sites/${siteId}/retry-provisioning`,
    {},
    authHeaders(),
  );
  return response.data;
};

// Fetch a login link and open wp-admin in a new tab. The tab is opened
// synchronously (before the request) so popup blockers allow it.
// NOTE: no 'noopener' feature string here — with it, window.open returns
// null, which made this fall back to navigating the CURRENT tab while the
// new tab sat on about:blank. We need the handle to steer the new tab;
// the opener link is severed manually instead.
export const openWpAdmin = async (siteId) => {
  const tab = window.open('about:blank', '_blank');
  if (tab) {
    tab.opener = null;
    try {
      tab.document.write(
        '<p style="font-family:system-ui,sans-serif;padding:24px">Opening WordPress…</p>',
      );
    } catch (writeError) {
      // Cosmetic only — fine if the browser disallows it.
    }
  }
  try {
    const { url } = await getWpLoginLink(siteId);
    if (tab && !tab.closed) {
      tab.location = url;
    } else {
      // Popup blocked entirely: last resort, navigate this tab.
      window.location.assign(url);
    }
  } catch (error) {
    if (tab) tab.close();
    throw error;
  }
};
